export const EDIT_PARTNER_RESOURCES_MUTATION = gql`
    mutation editPartnerResource($input: EditResourceInput!) {
        editPartnerResource(input: $input) {
            id
            name
            status
            type
            description
            imageUrl
            resourceUrl
            createdAt
            createdById
            permission
            section {
                id
                name
            }
        }
    }
`;

export const EDIT_PARTNER_RESOURCE_SECTION_MUTATION = gql`
    mutation editPartnerResourceSection($input: EditResourceSectionInput!) {
        editPartnerResourceSection(input: $input) {
            id
            name
            status
            pinnedAt
            order
        }
    }
`;
